import { Box } from '@glplus/glpweb-dsl';
import type { Category } from './types';

/** The deck's square icon tile on each category card (glyph on the accent). */
export function KitIcon({ category, size = 40 }: { category: Category; size?: number }) {
  const glyph = { flag: '⚑', dollar: '$', percent: '%', ledger: '▤', shield: '◆', link: '↗' }[category.icon];
  return (
    <Box sx={{ width: size, height: size, borderRadius: 2, backgroundColor: category.accent, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: size * 0.45, flexShrink: 0 }} aria-hidden="true">
      {glyph}
    </Box>
  );
}
